import { initialState } from "../../external/store/initialState";
import { AnyAction } from "redux";
import { VideoResponse } from "../types/videos";
import { commonActionKeys } from "../actions/commonActionKeys";

export default function appSettingsReducer(
  state: VideoResponse = initialState.videos,
  action: AnyAction
): VideoResponse {
  switch (action.type) {
    case commonActionKeys.LOAD_VIDEOS_SUCCESS:
      return { ...action.videoRes };
    default:
      return state;
  }
}
